import { findIndex } from 'lodash';
import api from 'src/api';
import { SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE } from 'src/store/modules/channel';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_CHANNELS_GROUPS_FOR_CHANNELS_GROUPS_STORE = 'SET_CHANNELS_GROUPS_FOR_CHANNELS_GROUPS_STORE';
export const FETCHING_CHANNELS_GROUP = 'FETCHING_CHANNELS_GROUP';
export const FETCHING_CHANNELS_GROUPS = 'FETCHING_CHANNELS_GROUPS';
export const STOP_FETCHING_CHANNELS_GROUPS = 'STOP_FETCHING_CHANNELS_GROUPS';
export const SYNC = 'SYNC';

const data = {
  channelsGroups: [],
  fetching: false,
  channelsGroupsTotal: 0,
  pageSizeDefault: undefined,
};

const actions = {
  fetchChannelsGroups({ commit }) {
    commit(FETCHING_CHANNELS_GROUPS);
    return api.getChannelsGroups().then((channelsGroups) => {
      commit(SET_CHANNELS_GROUPS_FOR_CHANNELS_GROUPS_STORE, { channelsGroups });
    })
      .catch((err) => {
        commit(STOP_FETCHING_CHANNELS_GROUPS);
        throw err;
      });
  },
  fetchChannelsGroupsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(FETCHING_CHANNELS_GROUPS);
    return api.getChannelsGroupsPagination(page, pageSize)
      .then(({ channelsGroups, totalCount, pageSizeDefault }) => {
        commit(SET_CHANNELS_GROUPS_FOR_CHANNELS_GROUPS_STORE, {
          channelsGroups, totalCount, moreData, pageSizeDefault,
        });
      })
      .catch((err) => {
        commit(STOP_FETCHING_CHANNELS_GROUPS);
        throw err;
      });
  },
  updateChannelsGroup({ commit, state }, { id, config, model }) {
    commit(FETCHING_CHANNELS_GROUP, id);
    return api.updateChannelsGroup(id, config, model).then((group) => {
      commit(SYNC, group);
      commit(`channel/${SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE}`, state.channelsGroups, { root: true });
    });
  },
  removeChannelsGroup({ commit, state }, id) {
    commit(FETCHING_CHANNELS_GROUP, id);
    return api.deleteChannelsGroup(id).then((group) => {
      commit('REMOVE_CHANNELS_GROUP', group.id);
      commit(`channel/${SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE}`, state.channelsGroups, { root: true });
    });
  },
  createChannelsGroup({ commit, state }, { config, model }) {
    return api.createChannelsGroup(config, model).then((channel) => {
      commit('ADD_CHANNELS_GROUP', channel);
      commit(SYNC, channel);
      commit(`channel/${SET_CHANNELS_GROUPS_FOR_CHANNEL_STORE}`, state.channelsGroups, { root: true });
    });
  },
};

const mutations = {
  ADD_CHANNELS_GROUP(state, group) {
    state.channelsGroups = [...state.channelsGroups, {
      ...group,
      fetching: false,
      channels: [],
    }];
  },
  SET_CHANNELS_GROUPS_FOR_CHANNELS_GROUPS_STORE(state, {
    channelsGroups, totalCount, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.channelsGroups = state.channelsGroups.concat(channelsGroups);
    } else {
      state.channelsGroups = channelsGroups;
    }
    state.channelsGroupsTotal = totalCount || state.channelsGroupsTotal;
    mutations.STOP_FETCHING_CHANNELS_GROUPS(state);
  },
  FETCHING_CHANNELS_GROUP(state, id) {
    const channelsGroups = [...state.channelsGroups];
    const group = channelsGroups[findIndex(channelsGroups, { id })];
    if (group.fetching) group.fetching = true;
  },
  FETCHING_CHANNELS_GROUPS(state) {
    state.fetching = true;
  },
  STOP_FETCHING_CHANNELS_GROUPS(state) {
    state.fetching = false;
  },
  SYNC(state, response) {
    const channelsGroups = [...state.channelsGroups];
    const index = findIndex(channelsGroups, { id: response.id });
    const group = channelsGroups[index];
    channelsGroups.splice(index, 1, { ...group, ...response, fetching: false });
    state.channelsGroups = channelsGroups;
  },
  REMOVE_CHANNELS_GROUP(state, id) {
    const channelsGroups = [...state.channelsGroups];
    const index = findIndex(channelsGroups, { id });
    channelsGroups.splice(index, 1);
    state.channelsGroups = channelsGroups;
    state.channelsGroupsTotal -= 1;
  },
};

const getters = {
  getChannelsGroupById(state) {
    const { channelsGroups } = state;
    return (id) => (channelsGroups[findIndex(channelsGroups, { id })]);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
  getters,
};

export default store;
